/* =========================================================
  requestJSON
========================================================= */
const requestJSON = (url, options = {}) => {

  return new Promise((resolve, reject) => {

    const method = options.method || 'GET';

    const xhr = new XMLHttpRequest();

    xhr.open(method, url, true);

    xhr.withCredentials = true;

    xhr.responseType = 'json';

    if (method === 'POST') {
      xhr.setRequestHeader(
        'Content-Type',
        'application/json'
      );
    }

    xhr.onload = () => {

      if (xhr.status >= 200 && xhr.status < 300) {

        resolve(xhr.response);

      } else {

        reject({
          status: xhr.status,
          response: xhr.response
        });

      }

    };

    xhr.onerror = () => {

      reject({
        status: xhr.status,
        response: xhr.response
      });

    };

    if (method === 'GET') {
      xhr.send();
    } else {
      xhr.send(options.body || null);
    }

  });

};

/* =========================================================
  Locale Root
========================================================= */
function getLocaleRoot() {

  const path = window.location.pathname;

  if (path.startsWith('/en')) return '/en/';
  if (path.startsWith('/th')) return '/th/';
  if (path.startsWith('/zh')) return '/zh/';
  if (path.startsWith('/fr')) return '/fr/';
  if (path.startsWith('/es')) return '/es/';

  return '/';

}

/* =========================================================
  Wait Element
========================================================= */
const waitElement = (selector, timeout = 10000) => {

  return new Promise((resolve, reject) => {

    const interval = 100;
    let elapsed = 0;

    const timer = setInterval(() => {

      const el = document.querySelector(selector);

      if (el) {

        clearInterval(timer);
        resolve(el);

      }

      elapsed += interval;

      if (elapsed >= timeout) {

        clearInterval(timer);
        reject();

      }

    }, interval);

  });

};

/* =========================================================
  Main
========================================================= */
(async () => {

  const localeRoot = getLocaleRoot();

  let form;
  let wrapper;

  try {

    form = await waitElement(
      '#AddToCartForm, form[action*="/cart/add"]'
    );

    wrapper = await waitElement(
      '.paymentButtonsWrapper'
    );

  } catch (e) {

    console.warn(
      '[Mixed Cart] Required elements not found'
    );

    return;

  }

  /* =========================================================
    Product Type
  ========================================================= */
  const digitalFlagInput = document.querySelector(
    '#ProductDigitalFlag'
  );

  const isCurrentProductDigital =
    digitalFlagInput?.value === 'true';

  const DIGITAL_VARIANT_IDS =
    (window.DIGITAL_VARIANT_IDS || [])
      .map(Number);

  /* =========================================================
    Locale
  ========================================================= */
  const locale =
    document.documentElement.lang.toLowerCase();

  const currentLang =
    locale.startsWith('en') ? 'en' :
    locale.startsWith('th') ? 'th' :
    locale.startsWith('zh') ? 'zh' :
    locale.startsWith('fr') ? 'fr' :
    locale.startsWith('es') ? 'es' :
    'ja';

  const TEXT = {

    ja: {
      message:
        'デジタル商品と物理商品は同時に購入できません。\nお手数ですが、別々にご購入ください。',
      button: 'カートを確認する'
    },

    en: {
      message:
        'Digital products and physical products cannot be purchased together. Please purchase them separately.',
      button: 'View Cart'
    },

    th: {
      message:
        'สินค้าดิจิทัลและสินค้าจริงไม่สามารถซื้อพร้อมกันได้ โปรดซื้อแยกกัน',
      button: 'ดูตะกร้าสินค้า'
    },

    zh: {
      message:
        '数字商品和实体商品无法同时购买。请您分别购买。',
      button: '查看购物车'
    },

    fr: {
      message:
        'Il n’est pas possible d’acheter simultanément des produits numériques et des produits physiques. Veuillez les acheter séparément.',
      button: 'Voir le panier'
    },

    es: {
      message:
        'No es posible comprar productos digitales y productos físicos al mismo tiempo. Le rogamos que los adquiera por separado.',
      button: 'Ver carrito'
    }

  };

  const LANG = TEXT[currentLang];

  /* =========================================================
    Initial Cart Check
  ========================================================= */
  try {

    console.log(
      '[Initial Cart Check]',
      localeRoot
    );

    const cart = await requestJSON(
      `${localeRoot}cart.js`
    );

    console.log('[Cart]', cart);

    const hasDigital = cart.items.some(item =>
      DIGITAL_VARIANT_IDS.includes(
        Number(item.variant_id)
      )
    );

    const hasPhysical = cart.items.some(item =>
      !DIGITAL_VARIANT_IDS.includes(
        Number(item.variant_id)
      )
    );

    const shouldBlock =
      (
        !isCurrentProductDigital &&
        hasDigital
      ) ||
      (
        isCurrentProductDigital &&
        hasPhysical
      );

    if (shouldBlock) {

      wrapper.classList.add(
        'is-cart-blocked'
      );

      document.querySelectorAll(
        '#AddToCart, .shopify-payment-button'
      ).forEach(el => el.remove());

      if (
        !wrapper.querySelector(
          '.cart-block-notice'
        )
      ) {

        const notice =
          document.createElement('div');

        notice.className =
          'cart-block-notice';

        notice.innerHTML = `
          <p class="cart-block-notice__text">${LANG.message}</p>

          <a
            href="${localeRoot}cart"
            class="cart-block-notice__button"
          >
            ${LANG.button}
          </a>
        `;

        wrapper.appendChild(notice);

      }

    }

  } catch (e) {

    console.error(
      '[Mixed Cart] Initial fetch failed',
      e
    );

  } finally {

    wrapper.classList.add('is-ready');

  }

  /* =========================================================
    Add To Cart Click
  ========================================================= */

  const addCartBtn = document.querySelector(
    '#AddToCart'
  );

  // 【追加】無限ループを防ぎ、検証通過後に元の送信処理を実行するためのバイパスフラグ
  let isValidationBypassed = false;

  if (addCartBtn) {

    addCartBtn.addEventListener('click', async (e) => {

      // 【追加】バリデーションを通過して再発火されたクリックイベントの場合は、
      // 処理を中断（早期リターン）し、テーマ本来のカート追加処理（Native flow）をそのまま走らせます。
      if (isValidationBypassed) {
        return;
      }

      // 【追加・変更】
      // デジタル・物販に関わらず、クリックされた瞬間に「同期処理」として
      // 一旦すべての送信イベント（デフォルト挙動）を一時停止し、裏で非同期のカート取得を安全に行います。
      e.preventDefault();

      /* =====================================================
        PHYSICAL PRODUCT
        → native flow (WS優先)
      ===================================================== */

      if (!isCurrentProductDigital) {

        /*
        物販商品は:
        - WorldShopping
        - theme native add-to-cart
        を優先する。

        custom Ajax add は使わない。
        */

        try {

          const cart = await requestJSON(
            `${localeRoot}cart.js`
          );

          const hasDigital =
            cart.items.some(item =>
              DIGITAL_VARIANT_IDS.includes(
                Number(item.variant_id)
              )
            );

          /*
          ----------------------------------------
          Mixed Cart Block
          ----------------------------------------
          */

          if (hasDigital) {

            alert(LANG.message);

            window.location.href =
              `${localeRoot}cart`;

            return;

          }

          /*
          ----------------------------------------
          physical item
          → native flow
          ----------------------------------------
          */
          // 【追加】チェックを無事通過した場合、フラグを立ててボタンクリックを再発火します。
          isValidationBypassed = true;
          addCartBtn.click();

          // 次回のボタン操作に備えて、フラグを非同期でリセットしておきます。
          setTimeout(() => {
            isValidationBypassed = false;
          }, 300);

          return;

        } catch (err) {

          console.error(
            '[Mixed Cart Validation Failed]',
            err
          );

          /*
          fail safe:
          バリデーション取得エラー時は、カート追加を許可（Native flowを再開）
          */
          isValidationBypassed = true;
          addCartBtn.click();
          setTimeout(() => {
            isValidationBypassed = false;
          }, 300);
          return;

        }

      }

      /* =====================================================
        DIGITAL PRODUCT
        → custom Ajax flow
      ===================================================== */

      // (※e.preventDefault() は先頭に移動したため、ここでの重複呼び出しは不要ですが、残しておいても動作に影響ありません)

      /*
      ----------------------------------------
      double click guard
      ----------------------------------------
      */
      if (
        addCartBtn.classList.contains('is-loading')
      ) {
        return;
      }

      addCartBtn.classList.add('is-loading');

      /*
      ----------------------------------------
      Spinner Add
      ----------------------------------------
      */
      if (!addCartBtn.querySelector('.custom-spinner')) {

        const spinner = document.createElement('i');

        spinner.className =
          'fa fa-circle-o-notch fa-spin fa-fw custom-spinner';

        addCartBtn.appendChild(spinner);

      }

      addCartBtn.disabled = true;

      try {

        /*
        ----------------------------------------
        Cart Check
        ----------------------------------------
        */
        const cart = await requestJSON(
          `${localeRoot}cart.js`
        );

        const hasPhysical =
          cart.items.some(item =>
            !DIGITAL_VARIANT_IDS.includes(
              Number(item.variant_id)
            )
          );

        /*
        ----------------------------------------
        Mixed Cart Block
        ----------------------------------------
        */
        if (hasPhysical) {

          alert(LANG.message);

          window.location.href =
            `${localeRoot}cart`;

          return;

        }

        /*
        ----------------------------------------
        Variant ID
        ----------------------------------------
        */
        const variantInput =
          form.querySelector('[name="id"]');

        const variantId =
          Number(variantInput?.value);

        if (!variantId) {

          console.error(
            '[Add Cart] Variant ID not found'
          );

          return;

        }

        /*
        ----------------------------------------
        Add To Cart
        ----------------------------------------
        */
        await requestJSON(
          `${localeRoot}cart/add.js`,
          {
            method: 'POST',
            body: JSON.stringify({
              id: variantId,
              quantity: 1
            })
          }
        );

        console.log(
          '[Add Cart] Success'
        );

        /*
        ----------------------------------------
        Update Cart Count
        ----------------------------------------
        */
        try {

          const updatedCart =
            await requestJSON(
              `${localeRoot}cart.js`
            );

          const countEls =
            document.querySelectorAll(
              '.cart-item-count-header--quantity'
            );

          countEls.forEach(el => {

            el.textContent =
              updatedCart.item_count || 0;

          });

        } catch (err) {

          console.error(
            '[Cart Count Update Failed]',
            err
          );

        }

        /*
        ----------------------------------------
        Success UI
        ----------------------------------------
        */
        addCartBtn.classList.add(
          'is-added'
        );

        setTimeout(() => {

          addCartBtn.classList.remove(
            'is-added'
          );

        }, 1200);

      } catch (err) {

        console.error(
          '[Add Cart] Failed',
          err
        );

      } finally {

        /*
        ----------------------------------------
        Spinner Remove
        ----------------------------------------
        */
        const spinner =
          addCartBtn.querySelector(
            '.custom-spinner'
          );

        if (spinner) {
          spinner.remove();
        }

        addCartBtn.classList.remove(
          'is-loading'
        );

        addCartBtn.disabled = false;

      }

    });

  }

})();